import React from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { Box, CircularProgress, Typography } from "@mui/material";
import { ReactComponent as ExclamatoryIcon } from "../../Icons/GraphExclamatoryIcon.svg";
import './Overview.css'

const VisitorGraph = () => {
  const { VisitorData, OverviewStatus } = useSelector(
    (state) => state.OverView
  );
  console.log(VisitorData);
  const VisitorSeries = [
    {
      name: "Visitor",
      data: [
        VisitorData?.monthly_counts?.jan || 0,
        VisitorData?.monthly_counts?.feb || 0,
        VisitorData?.monthly_counts?.mar || 0,
        VisitorData?.monthly_counts?.apr || 0,
        VisitorData?.monthly_counts?.may || 0,
        VisitorData?.monthly_counts?.jun || 0,
        VisitorData?.monthly_counts?.jul || 0,
        VisitorData?.monthly_counts?.aug || 0,
        VisitorData?.monthly_counts?.sep || 0,
        VisitorData?.monthly_counts?.oct || 0,
        VisitorData?.monthly_counts?.nov || 0,
        VisitorData?.monthly_counts?.dec || 0,
      ],
    },
  ];
  const options = {
    chart: {
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      events: {
        mouseMove: (event, chartContext) => {
          chartContext.el.style.cursor = "pointer";
        },
        mouseLeave: (event, chartContext) => {
          chartContext.el.style.cursor = "default";
        },
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      labels: {
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value;
        },
        style: {
          fontSize: "12px",
          fontFamily: "Inter, sans-serif",
          color: "#384250",
          fontWeight: 400,
        },
      },
    },
    colors: ["#800000", "#FF7C32", "#9A66FF"],
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        // borderRadius: 8,
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      theme: false,
      style: {
        background: "#262D33",
      },
      x: {
        show: false,
      },
      y: {
        title: {
          formatter: function () {
            return "";
          },
        },
      },
      marker: {
        show: false,
      },
      position: function (data, opts) {
    return {
      x: data.globals.cursorX + 20,  // shift right 10px
      y: data.globals.cursorY - 40,  // shift upward 20px
    };
  }
//       custom: function ({ series, seriesIndex, dataPointIndex, w }) {
//         const totalVisitors = series[0][dataPointIndex];
//         const month = w.globals.labels[dataPointIndex];

//         return `
//         <div class="background">
//         <div class="triangle">
       
//         <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M8 16V0L1.5 6.5L0.5 7.5L0 8L8 16Z" fill="#262D35"/>
// </svg>
       
//         </div>

//           <div class="apexcharts-tooltip-custom">
//             <div class="total-count-tip">
//               <div>
//               Visitors
//               </div> 
//               <div>
//                 ${totalVisitors} 
//               </div>
//             </div>
//             <div class="month-change-top">${month}${" "}${2023}</div>
//           </div>
//           </div>
//         `;
//       },
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "none",
          value: 0,
        },
      },
    },
   
  };
  return (
    <>
      {VisitorData?.overall_count ? (
        <Chart
          className={"visitor-chart"}
          options={options}
          series={VisitorSeries}
          type="bar"
          height={400}
        />
      ) : (
       <Box
                     sx={{
                       borderRadius: "0px, 0px, 8px, 8px",
                       padding: "16px",
                       backgroundColor: "#F9FAFB",
                       display: "flex",
                       flexDirection: "column",
                       justifyContent: "center",
                       alignItems: "center",
                       minHeight: "300px",
                     }}
                   >
                     {OverviewStatus ? (
                       <CircularProgress />
                     ) : (
                       <>
                         {" "}
                         <ExclamatoryIcon
                           style={{ marginBottom: "5px", marginTop: "60px" }}
                         />
                         <Typography
                           sx={{
                             color: "#9DA4AE",
                             fontSize: "16px",
                             fontWeight: 600,
                             width: "470px",
                             my: 2,
                             textAlign: "center",
                             marginTop: "5px",
                           }}
                           style={{ color: "#4D5761" }}
                         >
                           No statistics available for display
                         </Typography>
                         {/* <StyledSecondaryTypography
                           color="#9DA4AE !important"
                           textAlign="center"
                           width="400px"
                           height="88px"
                           fontSize="16px"
                           fontWeight="400px"
                           lineHeight="22.4px"
                           marginBottom="60px"
                         >
                           To get started, you can{" "}
                           <Link to="/building" style={{ color: "#0E4965" }}>
                             <b>click here </b>
                           </Link>
                           to add the facility via the facility page.
                         </StyledSecondaryTypography> */}
                       </>
                     )}
                   </Box>
      )}
    </>
  );
};

export default VisitorGraph;
